/**
 * Staat een advertentie nog in het aanbod, en zo niet: waarom vermoedelijk niet
 * (MA-22).
 *
 * De database kent twee standen (`status`: actief of verdwenen, zie historie.ts).
 * Dat is wat we waarnemen. Voor het scherm is één onderscheid erbij nodig: een
 * woning die verdween nadat Funda hem als verkocht (onder voorbehoud) toonde is
 * vrijwel zeker verkocht, en die wil je als referentie blijven zien. Een woning
 * die zonder dat merkje verdween is ingetrokken, verlopen of buiten het
 * zoekgebied geraakt - die hoort uit beeld tot hij terugkomt.
 *
 * Eerlijk over de grens: "verkocht" is hier "laatst gezien met een verkocht-
 * merkje". Funda haalt een definitief verkochte woning uit de gewone zoekresultaten;
 * wat we zien is dus de laatste stand vóór het verdwijnen, niet de akte.
 */
import { z } from 'zod';

export const AANBODSTANDEN = ['actief', 'verkocht', 'verdwenen'] as const;
export const aanbodSchema = z.enum(AANBODSTANDEN);
export type Aanbod = z.infer<typeof aanbodSchema>;

/** Wat er zonder filter in beeld staat: te koop, en wat als verkocht wegging. */
export const AANBOD_STANDAARD: readonly Aanbod[] = ['actief', 'verkocht'];

export const AANBOD_LABELS: Record<Aanbod, string> = {
  actief: 'Te koop',
  verkocht: 'Verkocht',
  verdwenen: 'Uit het aanbod',
};

/**
 * Het merkje dat op verkocht wijst: "Verkocht" en "Verkocht onder voorbehoud".
 * Dezelfde regel staat als SQL in packages/db (`aanbodExpressie`); de test daar
 * houdt de twee gelijk.
 */
export function isVerkochtMerkje(badge: string | null | undefined): boolean {
  return (badge ?? '').toLowerCase().includes('verkocht');
}

export function aanbodVan(
  status: 'actief' | 'verdwenen',
  badge: string | null | undefined,
): Aanbod {
  if (status === 'actief') return 'actief';
  return isVerkochtMerkje(badge) ? 'verkocht' : 'verdwenen';
}
